import React, { ReactElement } from "react";
import TopSalesProductDetailsReportList from "../../components/Reports/TopSalesProductDetails";
import MainLayout from "../../components/Layouts";

const TopSalesProductDetailsReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <TopSalesProductDetailsReportList />
    </MainLayout>
  );
}; 

export default TopSalesProductDetailsReportPage;
